import React from 'react';

import { Box, Grid, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import { promoTokenValidity } from '@pharmaplan/common';

import useProfessional from '../../../hooks/Professional/useProfessional';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { resetDialog } from '../../../reducers/dialogReducer';
import { useAppSelector } from '../../../hooks/useAppSelector';
import popup from '../../../assets/img/FR-ENG.png';
import strings from '../../../localization';

import styles from './styles';

const PromoApprovalModal = () => {
  const dispatch = useAppDispatch();

  const promoModal = useAppSelector(promoTokenValidity);

  const { isProfessional } = useProfessional();
  const { registrationPopupUrl } = promoModal ?? {};

  const handleClose = () => {
    dispatch(resetDialog());
  };

  return (
    <Box sx={styles.container}>
      <Grid sx={styles.close}>
        <IconButton size="small" sx={styles.closeIcon} onClick={handleClose}>
          <Close />
        </IconButton>
      </Grid>
      <img src={registrationPopupUrl ?? popup} alt="1" style={styles.image} />

      <Box sx={{ padding: 1, px: 2 }}>
        <Typography sx={styles.title}>
          {strings.thankYouForRegistering}
        </Typography>
        <Typography sx={styles.endText}>
          {isProfessional
            ? strings.yourBonusesWillBeApplied
            : strings.yourRatesWillBeApplied}
          <br />
          {strings.itWontBeLong}
        </Typography>
      </Box>
    </Box>
  );
};
export default PromoApprovalModal;
